import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EditNoteDialogData, EditNoteDialogResult } from '@portal-workspace/grow-shared-library';
import { MatButtonModule } from '@angular/material/button';
import { FlexModule } from '@angular/flex-layout/flex';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CustomAngularEditorComponent } from '../custom-angular-editor-component/custom-angular-editor.component';

@Component({
    templateUrl: './edit-note.dialog.html',
    styleUrls: ['./edit-note.dialog.scss'],
    standalone: true,
    imports: [MatFormFieldModule, MatInputModule, FormsModule, ReactiveFormsModule, FlexModule, MatButtonModule, MatDialogModule, CustomAngularEditorComponent]
})
export class EditNoteDialog {

  formGroup: FormGroup<{
    title: FormControl<string | null>;
    note: FormControl<string | null>;
  }>;
  formControlTitle: FormControl<string | null>;
  formControlNote: FormControl<string | null>;

  constructor(@Inject(MAT_DIALOG_DATA) public data: EditNoteDialogData,
              private matDialogRef: MatDialogRef<EditNoteDialog, EditNoteDialogResult>,
              private formBuilder: FormBuilder) {
    this.formControlTitle = formBuilder.control(data.title ?? null);
    this.formControlNote = formBuilder.control(data.note, [Validators.required]);
    this.formGroup = formBuilder.group({
      title: this.formControlTitle,
      note: this.formControlNote,
    });
  }

  onCancel() {
    this.matDialogRef.close();
  }

  onSubmit() {
    const title = this.formControlTitle.value?.trim();
    this.matDialogRef.close({
      readyForSubmission: true,
      title: title ? title : null,
      note: this.formControlNote.value ?? '',
    });
  }
}
